import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { css } from "@emotion/react";

import { theme } from "../../../utils/global-styles/theme";

import dayjs from "../../../utils/dayjsConfig";

import NotificationsMenu from "../Dropdowns/NotificationsMenu";

const NotificationBadge = ({ notificationLinks }) => {
  const [notificationsDisplay, setNotificationsDisplay] = useState("none");
  const [newNotificationCount, setNewNotificationCount] = useState(0);

  useEffect(() => {
    let count = 0;
    notificationLinks.forEach((link) => {
      if (link.viewDateTimeStamp === "null") {
        count += 1;
      }
    });
    setNewNotificationCount(count);
  }, [notificationLinks]);

  return (
    <div
      css={css`
        cursor: pointer;
        position: relative;
        margin-left: 3em;

        @media only screen and (max-width: ${theme.breakpoints.mobile}) {
          margin-left: 1em;
          display: none;
        }
      `}
      // TODO: Fix this logic to display new notifications and update the GraphQL data with viewDateTimeStamp for the when user views the notifications
      onClick={() => {
        if (notificationsDisplay === "block" && newNotificationCount > 0) {
          notificationLinks.forEach((link) => {
            link.viewDateTimeStamp = dayjs(new Date()).format();
          });
          setNewNotificationCount(0);
        }

        notificationsDisplay === "none"
          ? setNotificationsDisplay("block")
          : setNotificationsDisplay("none");
      }}
    >
      <svg width="16px" height="17px" viewBox="0 0 16 17">
        <defs>
          <rect x="3" y="3" width="13" height="15" id="rect-1"></rect>
        </defs>
        <g
          id="Icons-&amp;-Symbols"
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
        >
          <g id="Icons" transform="translate(-51.000000, -233.000000)">
            <g
              id="Icon/Notification-Badge"
              transform="translate(48.000000, 232.000000)"
            >
              <rect id="Rectangle" x="0" y="0" width="20" height="20"></rect>
              <g id="np_notification_1304329_000000">
                <image
                  x="3"
                  y="3"
                  width="13"
                  height="15"
                  href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAeCAYAAAAy2w7YAAAEGWlDQ1BrQ0dDb2xvclNwYWNlR2VuZXJpY1JHQgAAOI2NVV1oHFUUPrtzZyMkzlNsNIV0qD8NJQ2TVjShtLp/3d02bpZJNtoi6GT27s6Yyc44M7v9oU9FUHwx6psUxL+3gCAo9Q/bPrQvlQol2tQgKD60+INQ6Ium65k7M5lpurHeZe58853vnnvuuWfvBei5qliWkRQBFpquLRcy4nOHj4g9K5CEh6AXBqFXUR0rXalMAjZPC3e1W99Dwntf2dXd/p+tt0YdFSBxH2Kz5qgLiI8B8KdVy3YBevqRHz/qWh72Yui3MUDEL3q44WPXw3M+fo1pZuQs4tOIBVVTaoiXEI/MxfhGDPsxsNZfoE1q66ro5aJim3XdoLFw72H+n23BaIXzbcOnz5mfPoTvYVz7KzUl5+FRxEuqkp9G/Ajia219thzg25abkRE/BpDc3pqvphHvRFys2weqvp+krbWKIX7nhDbzLOItiM8358pTwdirqpPFnMF2xLc1WvLyOwTAibpbmvHHcvttU57y5+XqNZrLe3lE/Pq8eUj2fXKfOe3pfOjzhJYtB/yll5SDFcSDiH+hRkH25+L+sdxKEAMZahrlSX8ukqMOWy/jXW2m6M9LDBc31B9LFuv6gVKg/0Szi3KAr1kGq1GMjU/aLbnq6/lRxc4XfJ98hTargX++DbMJBSiYMIe9Ck1YAxFkKEAG3xbYaKmDDgYyFK0UGYpfoWYXG+fAPPI6tJnNwb7ClP7IyF+D+bjOtCpkhz6CFrIa/I6sFtNl8auFXGMTP34sNwI/JhkgEtmDz14ySfaRcTIBInmKPE32kxyyE2Tv+thKbEVePDfW/byMM1Kmm0XdObS7oGD/MypMXFPXrCwOtoYjyyn7BV29/MZfsVzpLDdRtuIZnbpXzvlf+ev8MvYr/Gqk4H/kV/G3csdazLuyTMPsbFhzd1UabQbjFvDRmcWJxR3zcfHkVw9GfpbJmeev9F08WW8uDkaslwX6avlWGU6NRKz0g/SHtCy9J30o/ca9zX3Kfc19zn3BXQKRO8ud477hLnAfc1/G9mrzGlrfexZ5GLdn6ZZrrEohI2wVHhZywjbhUWEy8icMCGNCUdiBlq3r+xafL549HQ5jH+an+1y+LlYBifuxAvRN/lVVVOlwlCkdVm9NOL5BE4wkQ2SMlDZU97hX86EilU/lUmkQUztTE6mx1EEPh7OmdqBtAvv8HdWpbrJS6tJj3n0CWdM6busNzRV3S9KTYhqvNiqWmuroiKgYhshMjmhTh9ptWhsF7970j/SbMrsPE1suR5z7DMC+P/Hs+y7ijrQAlhyAgccjbhjPygfeBTjzhNqy28EdkUh8C+DU9+z2v/oyeH791OncxHOs5y2AtTc7nb/f73TWPkD/qwBnjX8BoJ98VQNcC+8AAABsZVhJZk1NACoAAAAIAAQBGgAFAAAAAQAAAD4BGwAFAAAAAQAAAEYBKAADAAAAAQACAACHaQAEAAAAAQAAAE4AAAAAAAAASQAAAAEAAABIAAAAAQACoAIABAAAAAEAAAAaoAMABAAAAAEAAAAeAAAAAI1pMs4AAAAJcEhZcwAACzoAAAsTASA5yOYAAAG5SURBVEgN7Za9LwRBGMZxhDgKCS4SoZKIEJ2Q6El0ChUSjUqn04go/AMSpSj1Ogpa/4JIrnISFSLi2++Rncvu3H7M3c51nuSX2d1553l3Zmff3UJLfeonfB0m4QY+wLuGcLyEn4AT2h7wrlUcTRK1LzDvmqXNNZC4khXbwbmW0ptmcTqCCoRnpGM9pwOYgIbVzch9eAY7gX1+T8wWaJZ1qZfoU7AN086/iN+FAjhJd6WlSjNN6ntl3IZTFoKW4ROSzLKu3zJ2HFLVSe8FZJll9e/h0ZqWaYZOvR9ZRln913gMhBPZ79EUndpteTWKwUjYxE6kMuNDKk2Rl9lO1O4jCx56PhEvO5GnPLU2/4lq18Txir10347jXML0rlVlJypWe/IdyFdVpipTaRe5sglroMqdV9raYzAIT6DPyN93RFU3q6w02q8iO6cZXUEXNEt9GD9qLZuZxNx8UWt5CMMQ2SUmImj1/6YvaFzp16pEyk0wxjT6tp3HDTQB4XaakxLY21/jy6CflNyS2TEkbYad3BlCBkscv8cku+OaZutNeg7b8ABmZtq2K+Ak12dkzPRzvwBvcAZlcNIvyyKqBwXiH5kAAAAASUVORK5CYII="
                />
                <use fill={theme.colors.dkGray} fillRule="evenodd"></use>
              </g>
              {/* If the badge has notifications it will display the colored circle. */}
              {newNotificationCount > 0 && (
                <circle
                  id="Oval"
                  stroke="#FFFFFF"
                  strokeWidth="1"
                  fill={theme.colors.secondary}
                  fillRule="evenodd"
                  cx="14"
                  cy="6"
                  r="4"
                ></circle>
              )}
            </g>
          </g>
        </g>
      </svg>
      <NotificationsMenu
        display={notificationsDisplay}
        notificationLinks={notificationLinks}
        newNotificationCount={newNotificationCount}
      />
    </div>
  );
};

NotificationBadge.propTypes = {
  notificationLinks: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      datePublished: PropTypes.string,
      url: PropTypes.string,
      viewDateTimeStamp: PropTypes.string,
    })
  ),
};

export default NotificationBadge;
